<div *ngIf="caption || filter || dropdownFilter" class="caption">
  <div class="caption-wrapper">
    <!-- Custom static caption template -->
    <ng-container *ngIf="caption">
      <ng-container *ngTemplateOutlet="caption"></ng-container>
    </ng-container>

    <!-- Input-based filtering -->
    <cp-input *ngIf="filter" class="table-filter" type="text" [search]="true" placeholder="Common.search" [cpModel]="filterValue"
              (cpModelChange)="onFilterChange($event)">
    </cp-input>

    <!-- Dropdown-based filtering -->
    <cp-select *ngIf="dropdownFilter && rows" class="dropdown-filter" [clearable]="true" [options]="dropdownFilterOptions"
               [placeholder]="dropdownFilterPlaceholder" (selectionChange)="onDropdownFilterChange($event)">
    </cp-select>
  </div>
</div>
<table *ngIf="rows && columns?.length > 0" [ngClass]="tableClass" [class.mod-auto-columns]="autoColumns">
  <thead cp-head *ngIf="!hideHeaders" [columns]="columns" [inlineActions]="inlineActions" [hideActions]="hideActions"
                 [sortedBy]="sortedBy" [isAllSelected]="isAllSelected" [panel]="panel"
                 [hideSelection]="hideSelection" (toggleAll)="toggleAll()" (sort)="onSort($event)">
  </thead>
  <tbody #rowElement cp-body *ngFor="let row of visibleRows; trackBy: identify"
         class="table-row-group"
         [row]="row" [columns]="columns" [selection]="visibleSelection"
         [inlineActions]="inlineActions" [panel]="panel" [hideSelection]="hideSelection"
         [hideActions]="hideActions" [secondaryRow]="secondaryRow" [rowClass]="rowClass"
         (click)="onRowClick(row)"
         (contextmenu)="onContextMenu(row, rowElement, $event)"
         [cpTooltip]="tooltip" [data]="row" [tooltipEnabled]="tooltip"
         (toggleSelection)="toggleSelection($event)"
         (inlineAction)="onActionClicked($event)">
  </tbody>
</table>
<cp-paginator *ngIf="showPaginator"
              class="paginator"
              [itemCount]="modelRows.length"
              [itemsPerPage]="pagination"
              (pageChange)="onPageChange($event)">
</cp-paginator>

